import "./styles.scss";
import NavComponent from "../Nav";

interface JumbotronComponentProps {
  videoUrl: string;
  customButton?: React.ReactNode;
  imgUrl?: string;
  imgAlt?: string;
  navLinkUrl?: string; // destination for the Order Now button / customButton
  openInNewTab?: boolean;
}

const JumbotronComponent = ({
  videoUrl,
  customButton,
  imgUrl,
  imgAlt = "SouledOut logo",
  navLinkUrl,
  openInNewTab = false,
}: JumbotronComponentProps) => {
  const target = openInNewTab ? "_blank" : undefined;
  const rel = openInNewTab ? "noopener noreferrer" : undefined;

  return (
    <div className="jumbotron-container relative">
      {/* Nav overlay - centered on mobile, top-left on larger screens */}
      <div className="absolute top-4 left-1/2 transform -translate-x-1/2 z-20 sm:top-6 sm:left-6 sm:transform-none sm:translate-x-0 lg:top-8 lg:left-8">
        <NavComponent />
      </div>
      <video
        src={videoUrl}
        autoPlay
        muted
        loop
        controls
        playsInline
        className="w-full h-[60vh] sm:h-[70vh] md:h-[80vh] lg:h-[85vh] object-cover"
      />
      {customButton && (
        <div className="hidden sm:block absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 sm:top-4 sm:right-4 sm:left-auto sm:transform-none sm:translate-x-0 sm:translate-y-0 z-20">
          {navLinkUrl ? (
            <a
              href={navLinkUrl}
              target={target}
              rel={rel}
              className="inline-block bg-sow-gold text-black border-none cursor-pointer font-bold rounded-full"
              data-testid="jumbotron-nav-link"
            >
              {customButton}
            </a>
          ) : (
            customButton
          )}
        </div>
      )}
      {imgUrl && (
        <div className="absolute bottom-24 right-2 sm:bottom-20 sm:right-4 z-20">
          <img
            src={imgUrl}
            alt={imgAlt}
            className="w-10 h-10 sm:w-32 sm:h-32 md:w-48 md:h-48 lg:w-48 lg:h-48 object-cover"
          />
        </div>
      )}
    </div>
  );
};

export default JumbotronComponent;
